export default __webpack_public_path__ + "static/media/logoSimple.e465a983.png";